import CustomerWishlist from "@/models/CustomerWishlist";
import type {
  ActionTree,
  GetterTree,
  Module,
  MutationTree,
} from "vuex/types/index.js";
import type { RootState } from "..";

export interface WishlistState {
  primaryWishlist?: CustomerWishlist;
}

const state = (): WishlistState => ({
  primaryWishlist: undefined,
});

const getters: GetterTree<WishlistState, RootState> = {
  primaryWishlist(state): CustomerWishlist | undefined {
    return state.primaryWishlist;
  },
};

const mutations: MutationTree<WishlistState> = {
  setPrimaryWishlist(state, wishlist: CustomerWishlist) {
    state.primaryWishlist = wishlist;
  },
};

const actions: ActionTree<WishlistState, RootState> = {
  async fetchPrimaryWishlist({ commit, rootGetters }) {
    try {
      const user = rootGetters["auth/getCustomer"];
      if (!user || !user.id) {
        throw new Error("User is not authenticated or does not have an ID");
      }
      const wishlists = await CustomerWishlist.getOrCreateByCustomer(user.id);
      const primaryWishlist = wishlists?.at(0) || null;
      commit("setPrimaryWishlist", primaryWishlist);
    } catch (error) {
      console.error("Error fetching primary wishlist:", error);
      commit("setPrimaryWishlist", undefined); // Reset state on error
    }
  },
};

const wishlist: Module<WishlistState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default wishlist;
